import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IStepwizardProps } from "../../../typings/models/StepwizardProps";

const Stepwizard = (props: IStepwizardProps) => {
    return (
        <div className="stepwizard">
            <div className="stepwizard-row setup-panel row justify-content-center">
                {
                    props.steps.map((x, ind: number) => {
                        return <div className={`stepwizard-step col-2 ${props.currentStep > (ind + 1) ? 'completed' : props.currentStep == (ind + 1) ? 'current-active' : ''}`}>
                            <a type="button" className={`btn btn-border ${props.currentStep < (ind + 1) ? 'disabled' : ''}`}>
                                <span className="step-circle">
                                    {props.currentStep > (ind + 1) ? <FontAwesomeIcon icon={faCheck} /> : <p>{ind + 1}</p>}
                                </span>
                            </a>
                            <p>{x.name}</p>
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default Stepwizard;
